import Option from "./Option";
import { QuestionUsage } from "./Question";
export default class QuestionTemplate {
  constructor({
    id = Number.NaN,
    slug = "",
    name = "",
    label = "",
    typeQuestion = "",
    helpText = "",
    helpFile = null,
    hasFreeOption = false,
    options = [],
    canWizidee = false,
    isOperationResult = false,
    isOperationSource = false,
    usage = null,
  } = {}) {
    this.id = Number.parseInt(id);
    this.slug = slug;
    this.name = name;
    this.label = label;
    this.typeQuestion = typeQuestion;
    this.helpText = helpText;
    this.helpFile = helpFile;
    this.hasFreeOption = hasFreeOption;
    this.options = options ? options.map((choice) => new Option(choice)) : [];
    this.canWizidee = canWizidee;
    this.isOperationResult = isOperationResult;
    this.isOperationSource = isOperationSource;
    this.usage = usage ? new QuestionUsage(usage) : null;
  }
}
